import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';




const FieldTripClass82026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/5.webp`;
const p6 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/6.webp`;
const p7 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/7.webp`;
const p8 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/8.webp`;
const p9 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/9.webp`;
const p10 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/10.webp`;
const p11 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/11.webp`;
const p12 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Field-Trip8/12.webp`;
  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}
,{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},{
    src: p8,
    source: p8,                         
    rows: 1,
    cols: 1,
},{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
}



  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      FIELD TRIP CLASS 8
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 8	 Date: 09 September 2026 

        </Typography>
        

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
On Wednesday, 9 September 2026, National Public School, Yeshwanthpur, organised a field trip for Class 8 students to Camp Vama, offering a refreshing break amidst the scenic surroundings of Nandi Hills. The day began with engaging
 activities that immediately captured the students' enthusiasm and curiosity.
 <br></br>
Throughout the visit, students participated in obstacle challenges, rifle firing and various games paired with experiential learning. Their active involvement reflected strong teamwork and determination, supported by a safe, 
nature-filled environment that fostered confidence and collaboration.  
     <br></br>
Ultimately, the trip was far more than a recreational outing. By blending education with outdoor activity, it highlighted the value of physical well-being and 
left the students with cherished memories and a deeper appreciation for nature.       
  <br></br>
       
        
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   Smiles, sunshine and a whole lot of camp fun.

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTripClass82026;